/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-09 12:08:59
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-09 12:34:02
 */

import MessageBox from './MessageBox';

export default MessageBox;
